/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ISystemActionSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.IWorkflowBlock;
        systemActions: Wars.Domain.Model.SystemAction[];
        processSchemaProperties: Wars.Domain.Model.SchemaProperty[];
        processActionId: string,
        isReadonly: boolean;
        openOutputOrderModal: () => void;
    }

    export class SystemActionSettingsModalController extends BaseModalController {
        scope: ISystemActionSettingsModalControllerScope;

        constructor(
            $scope: ISystemActionSettingsModalControllerScope,
            systemLevelService: services.SystemLevelService,
            processConfigurationService: services.ProcessConfigurationService,
            workflowBlock: models.SystemActionWorkflowBlock,
            processConfigId: string,
            processActionId: string,
            isReadonly: boolean,
            workflowService: services.WorkflowService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            systemLevelService.getSystemLevelSystemActions().then(
                (systemLevel) => {
                    this.scope.systemActions = systemLevel.mySystemActions;
                });
            processConfigurationService.getProcessSchemaProperties(processConfigId).then(
                (processSchemaProperties) => {
                    this.scope.processSchemaProperties = processSchemaProperties;
                });

            this.scope.isReadonly = isReadonly;

            this.scope.openOutputOrderModal = () => {
                workflowService.showOutputOrderModal(this.scope.workflowBlock, this.scope.isReadonly);
            }
        }
    }
}

warsApp.registerController('SystemActionSettingsModalController',
    ['$scope', 'systemLevelService', "processConfigurationService", 'workflowBlock', 'processConfigId', 'processActionId', 'isReadonly', 'workflowService', 'close']);